import React from 'react';
import styled from 'styled-components';

interface GridAreaOutputsProps {
  readonly children: React.ReactNode;
}

export function GridAreaOutputs({children}: GridAreaOutputsProps): JSX.Element {
  return (
    <GridAreaOutputsWrapper>
      <OutputWrapper>{children}</OutputWrapper>
    </GridAreaOutputsWrapper>
  );
}

const OutputWrapper = styled.div`
  background: ${(props) => props.theme.brand.colors.resultArea.background};

  @media (min-width: ${(props) =>
      props.theme.brand.spacing.customOneColumnBreakpoint ||
      props.theme.internal.Breakpoints.b960}px) {
    display: grid;
    grid-template-columns: 2fr 3fr;
  }
`;

const GridAreaOutputsWrapper = styled.div`
  grid-area: output;
  align-self: start;
  margin-block-start: ${(props) =>
    props.theme.brand.spacing.oneColumnSimulatorContentLayout?.blockGap ?? '0'};
  padding-inline-start: ${(props) =>
    props.theme.brand.spacing.outputSectionRangeLayout?.inlineStart};
  padding-inline-end: ${(props) =>
    props.theme.brand.spacing.outputSectionRangeLayout?.inlineEnd};

  @media (min-width: ${(props) =>
      props.theme.brand.spacing.customOneColumnBreakpoint ||
      props.theme.internal.Breakpoints.b960}px) {
    grid-column: 1 / span 2;
    width: calc(100% + ${(props) => props.theme.internal.size.static510});
    margin-block-start: ${(props) =>
      props.theme.brand.spacing.twoColumnSimulatorContentLayout?.blockGap ??
      '0'};
  }
`;
